import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';

// 外部传入数据，转为下载接口所需要参数
const getDownloadApiParams = (params: any) => {
  return params;
};

const getSummarySheet = () => {
  const list: any[] = [];
  return list;
};

const getFileName = (params: any) => {
  const { start_release_time, start_date, end_release_time, end_date, new_style_donwload_file_name } = params;
  if (start_date && end_date) {
    return `${new_style_donwload_file_name}_${start_date}_${end_date}`;
  }
  if (start_release_time && end_release_time) {
    return `${new_style_donwload_file_name}_Release_${start_release_time}_${end_release_time}`;
  }
  return `${new_style_donwload_file_name}`;
};

export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    isUsingNewMethod: false, // 必传
    $$fileName: getFileName(params),
    downloadFetchApi: params.api,
    summarySheet: getSummarySheet(),
    downloadApiParams: getDownloadApiParams(params),
    downloadMode: 'commonConf',  // 使用最新版下载
    downloadConfigKey: params.downloadConfigKey, // trueAllDataDownloadExcel
    fetchOnlyOnce: false, // 是否只下载一次
  };
};
